import React from "react"

import { Button, type ButtonProps } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export const NOTIFICATION_DETAIL_ACTION_BUTTON_CLASS =
  "h-8 shrink-0 px-5 text-[0.75rem] normal-case tracking-normal"

export function NotificationDetailActionButton({
  label,
  dataAttr,
  onClick,
  className,
  variant = "gradient",
}: {
  label: string
  dataAttr?: string
  onClick: () => void
  className?: string
  variant?: ButtonProps["variant"]
}): React.ReactElement {
  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      data-font="primary"
      className={cn(NOTIFICATION_DETAIL_ACTION_BUTTON_CLASS, className)}
      data-notification-detail-action-button={dataAttr ?? undefined}
      onClick={onClick}
    >
      <span className="truncate normal-case tracking-normal">{label}</span>
    </Button>
  )
}
